import cn from 'classnames';
import PropTypes from 'prop-types';

function LdsCard({
  ariaLabel = undefined,
  children,
  classes = undefined,
  className,
  role = undefined,
  grow = false,
  ...rest
}) {
  return (
    <div
      aria-label={ariaLabel}
      className={cn(
        'lds-card',
        className,
        {
          grow,
          [`${classes}`]: classes,
        }
      )}
      role={role}
      {...rest}
    >
      {children}
    </div>
  );
}

function Body({
  children,
  className,
  ...rest
}) {
  return (
    <div
      className={`card-body ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
LdsCard.Body = Body;

function Footer({
  children,
  className,
  ...rest
}) {
  return (
    <div
      className={`card-footer ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
LdsCard.Footer = Footer;

export default LdsCard;

LdsCard.propTypes = {
  ariaLabel: PropTypes.string,
  classes: PropTypes.string,
  role: PropTypes.string,
  grow: PropTypes.bool,
};
